export enum Parameter {
  //Club parameters
  ClubSpeed = 1,
  AttackAngle = 2,
  ClubPath = 3,
  DynamicLoft = 4,
  FaceAngle = 5,
  SpinLoft = 6,
  FaceToPath = 7,
  SwingPlane = 8,
  SwingDirection = 9,
  //Launch parameters
  BallSpeed = 10,
  SmashFactor = 11,
  LaunchAngle = 12,
  LaunchDirection = 13,
  SpinRate = 14,
  SpinAxis = 15,
  //Flight parameters
  Height = 16,
  Carry = 17,
  Total = 18,
  Side = 19,
  SideTotal = 20,
  LandingAngle = 21,
  DistanceToPin = 22,
  DistanceToTarget = 23,
  HangTime = 24,
  LastData = 25,
  Score = 26,
  LowPointDistance = 27,
  //Skid and roll parameters
  //DistanceScore = 28,
  //DirectionScore = 29,
  EffectiveStimp = 30,
  SpeedDrop = 31,
  RollPercentage = 32,
  //RollDeceleration = 33,
  RollSpeed = 34,
  SkidDistance = 35,
  TotalBreak = 36,
  TrackDistance = 37,

  //Extra units form the Trackman Data Units project
  Dispersion = 38,
  Temperature = 39,
  Altitude = 40,
  LengthToTarget = 41,

  //Extra units from the TPS Units.cs project - callibration units
  //TargetHeight = 41,
  //TargetDistance = 42,
  //TargetSide = 43,
  //TeeHeight = 44,
  //TeeDistance = 45

  //Impact location
  ImpactOffset = 46,
  ImpactHeight = 47,

  //Additional parameters added to the TPS
  BackswingTime = 48,
  ForwardswingTime = 49,
  Tempo = 50,
  StrokeLength = 51,
  DynamicLie = 52,
  Curve = 53,

  //Replacements for putting reports (Total and Last data)
  Distance = 54,
  TrackedDistance = 55,
  SideDistance = 56,

  //New parameters
  BallSpeedDifference = 57,
  SpinRateDifference = 58,
  SpinIndex = 59,
  SmashIndex = 60,

  Undefined = 1000,
}

export function GetParameter(s: string): Parameter {
  switch (s) {
    case 'ClubSpeed':
      return Parameter.ClubSpeed;
    case 'AttackAngle':
      return Parameter.AttackAngle;
    case 'ClubPath':
      return Parameter.ClubPath;
    case 'DynamicLoft':
      return Parameter.DynamicLoft;
    case 'FaceAngle':
      return Parameter.FaceAngle;
    case 'SpinLoft':
      return Parameter.SpinLoft;
    case 'FaceToPath':
      return Parameter.FaceToPath;
    case 'SwingPlane':
      return Parameter.SwingPlane;
    case 'SwingDirection':
      return Parameter.SwingDirection;
    case 'BallSpeed':
      return Parameter.BallSpeed;
    case 'SmashFactor':
      return Parameter.SmashFactor;
    case 'LaunchAngle':
      return Parameter.LaunchAngle;
    case 'LaunchDirection':
      return Parameter.LaunchDirection;
    case 'SpinRate':
      return Parameter.SpinRate;
    case 'SpinAxis':
      return Parameter.SpinAxis;
    case 'Height':
      return Parameter.Height;
    case 'Carry':
      return Parameter.Carry;
    case 'Total':
      return Parameter.Total;
    case 'Side':
      return Parameter.Side;
    case 'SideTotal':
      return Parameter.SideTotal;
    case 'LandingAngle':
      return Parameter.LandingAngle;
    case 'DistanceToPin':
      return Parameter.DistanceToPin;
    case 'DistanceToTarget':
      return Parameter.DistanceToTarget;
    case 'HangTime':
      return Parameter.HangTime;
    case 'LastData':
      return Parameter.LastData;
    case 'Score':
      return Parameter.Score;
    case 'LowPointDistance':
      return Parameter.LowPointDistance;
    case 'EffectiveStimp':
      return Parameter.EffectiveStimp;
    case 'SpeedDrop':
      return Parameter.SpeedDrop;
    case 'RollPercentage':
      return Parameter.RollPercentage;
    case 'RollSpeed':
      return Parameter.RollSpeed;
    case 'SkidDistance':
      return Parameter.SkidDistance;
    case 'TotalBreak':
      return Parameter.TotalBreak;
    case 'TrackDistance':
      return Parameter.TrackDistance;
    case 'Dispersion':
      return Parameter.Dispersion;
    case 'Temperature':
      return Parameter.Temperature;
    case 'Altitude':
      return Parameter.Altitude;
    case 'LengthToTarget':
      return Parameter.LengthToTarget;
    case 'ImpactOffset':
      return Parameter.ImpactOffset;
    case 'ImpactHeight':
      return Parameter.ImpactHeight;
    case 'BackswingTime':
      return Parameter.BackswingTime;
    case 'ForwardswingTime':
      return Parameter.ForwardswingTime;
    case 'Tempo':
      return Parameter.Tempo;
    case 'StrokeLength':
      return Parameter.StrokeLength;
    case 'DynamicLie':
      return Parameter.DynamicLie;
    case 'Curve':
      return Parameter.Curve;
    case 'Distance':
      return Parameter.Distance;
    case 'TrackedDistance':
      return Parameter.TrackedDistance;
    case 'SideDistance':
      return Parameter.SideDistance;
    case 'BallSpeedDifference':
      return Parameter.BallSpeedDifference;
    case 'SpinRateDifference':
      return Parameter.SpinRateDifference;
    case 'SpinIndex':
      return Parameter.SpinIndex;
    case 'SmashIndex':
      return Parameter.SmashIndex;
    default:
      return Parameter.Undefined;
  }
}
